import Card from '@material-ui/core/Card'
import img from '../../assets/images/banner.jpg'
import TextField from '@material-ui/core/TextField'
import {FormHelperText, Select} from '@mui/material'
import CardCarousel from '../../pages/HomeNotConnected/CardCarousel'
import Skeleton from '@material-ui/lab/Skeleton'
import Button from '@mui/material/Button'
import React, { useEffect, useState } from 'react'
import allActions from '../../redux/actions/user'
import { useStyles } from './ProfessorGridStyle'
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import SearchIcon from "@material-ui/icons/Search";

export default function ProfessorGrid() {
  const classes = useStyles()

  const [allProfessors, setAllProfessors] = useState([])
  const [isNoProfFound, setIsNoProfFound] = useState(false)
  const [filteredProfessors, setFilteredProfessors] = useState([])
  const [allCenters, setAllCenters] = useState([])
  const [search, setSearch] = useState('')
  const [selectedCenter, setSelectedCenter] = useState('')
  const [displayedProfessors, setDisplayedProfessors] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  function onClickMoreDisplay() {
    if (filteredProfessors.length > 0) {
      setDisplayedProfessors(filteredProfessors.slice(0, displayedProfessors.length + 12))
    } else {
      setDisplayedProfessors(allProfessors.slice(0, displayedProfessors.length + 12))
    }
  }

  function onClickSearch() {
    const filtered = allProfessors.filter(professor => {
      if (selectedCenter != '' && search != '') {
        return ((professor.name.toLowerCase().includes(search.toLowerCase()) || professor.surname.toLowerCase().includes(search.toLowerCase())) && professor?.centres?.map(center => center.id).includes(selectedCenter))
      } else if (selectedCenter != '') {
        return professor.centres.map(center => center.id).includes(selectedCenter)
      } else if (search != '') {
        return professor.name.toLowerCase().includes(search.toLowerCase()) || professor.surname.toLowerCase().includes(search.toLowerCase())
      } else {
        return true
      }
    })
    setIsNoProfFound(filtered.length === 0)
    setFilteredProfessors(filtered)
    setDisplayedProfessors(filtered.slice(0, 12))
  }

  function hasMoreProfessors() {
    return displayedProfessors.length < (filteredProfessors.length > 0 ? filteredProfessors.length : allProfessors.length)
  }

  useEffect(() => {
    const fetchProfessors = async () => {
      try {
        setLoading(true)
        const result = await allActions.fetchGetAPI('api/professeur/')
        setAllProfessors(result.json)
        setDisplayedProfessors(result.json.slice(0, 12))
        setLoading(false)
      } catch (err) {
        setError(err)
      }
    }

    const fetchAllCenters = async () => {
      try {
        const result = await allActions.fetchGetAPI('api/center/')
        setAllCenters(result.json)
      } catch (err) {
        setError(err)
      } finally {
        setLoading(false)
      }
    }

    fetchProfessors()
    fetchAllCenters()
  }, [])

  return (
    <section className={classes.sectionHome}>
      <Card className={classes.cardCarousel} style={{ backgroundImage: `url(${img})` }}>
        <div className={classes.containerProfs}>
          <div className={classes.containerTitle}>
            <h2 className={classes.title} id={'professeurs'}>Listes des Professeurs</h2>
            <div className={classes.containerForm}>
              <TextField
                label="Rechercher par nom/prénom"
                variant="filled"
                fullWidth
                type="text"
                color={'secondary'}
                className={classes.formSelect}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                margin="dense"
              />
              <FormControl variant="outlined" className={classes.formSelect} style={{ width: '100%' }}>
                <Select
                  native
                  variant="filled"
                  value={selectedCenter}
                  onChange={(e) => setSelectedCenter(e.target.value)}
                  margin="dense"
                  className={classes.selectNative}
                  style={{ width: '100%' }}>
                  <option value="">Tous les centres</option>
                  {allCenters?.map((center, index) =>
                    <option key={index} value={center.id}>{center.libelle}</option>
                  )}
                </Select>
              </FormControl>
              <Button onClick={onClickSearch} variant="contained" color="primary" className={classes.buttonSearch}>
                <SearchIcon className={classes.iconSearch}/>
                Rechercher
              </Button>
            </div>
          </div>
          <div className={classes.gridContainer}>
            {isNoProfFound ?
              <h3 style={{textAlign: 'center'}}>Aucun professeur trouvé</h3> :
              (!loading && displayedProfessors.length > 0) ? displayedProfessors.map((professor, index) =>
                <CardCarousel key={index} professor={professor}/>
              ) : (
                <>
                  {Array(12).fill(0).map((_, index) =>
                    <Skeleton variant="rectangular" width={'100%'} height={300} />
                  )}
                </>
              )
            }
          </div>
          {!isNoProfFound && hasMoreProfessors() && <Button onClick={onClickMoreDisplay} variant="contained" color="secondary" className={classes.more}>Voir plus</Button>}
        </div>
      </Card>
    </section>
  )
}
